import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTie, faFileInvoiceDollar, faClipboardList, faChartBar, faCalendarCheck, faCalendarAlt, faCogs, faBriefcase } from '@fortawesome/free-solid-svg-icons';
import '../../styles/LandingPage.css';
import { useAuth } from '../../hooks/useAuth';

const EmployeeDashboard = () => {
  const { rolePermissions } = useAuth();

  function MyLink(props) {
    if (rolePermissions[props.path]?.View === 'true') {
      return (
        <Link to={props.path} className="link-card">
          <FontAwesomeIcon icon={props.iconname} size="3x" className="icon" />
          <p>{props.name}</p>
        </Link>
      );
    }

    return null;
  }

  return (
    <div className="landing-page">
      <div className="links-container">
        <MyLink path="/employee-list" iconname={faUserTie} name="Employee List" />
        <MyLink path="/employee-payment-list" iconname={faFileInvoiceDollar} name="Employee Payments" />
        <MyLink path="/nassit-schedule" iconname={faClipboardList} name="NASSIT Schedule" />
        <MyLink path="/employee-salaries" iconname={faChartBar} name="Employee Salaries Report" />
        <MyLink path="/leave-requests" iconname={faCalendarCheck} name="Leave Requests" />
        <MyLink path="/employee-benefits" iconname={faBriefcase} name="Employee Benefits" />
        <MyLink path="/leave-balances" iconname={faCalendarAlt} name="Leave Balances" />
        <MyLink path="/leave-policy" iconname={faCogs} name="Leave Policy" />
      </div>
    </div>
  );
};

export default EmployeeDashboard;
